import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { openLangSelector, openMenuMobile, setHeaderHeight, setHeaderWidth } from "../../redux";
import { useGoPage } from "../../hooks/useGoPage";

import "./style.css";

function Header() {
    const goPage = useGoPage();
    const dispatch = useDispatch();
    const location = useLocation();
    const headerRef = useRef(null);

    const isOpen = useSelector(state => state.options.menuMobile);
    const headerHeight = useSelector(state => state.options.headerHeight);

    const [isVisible, setIsVisible] = useState(true);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [scrollReference, setScrollReference] = useState(0);

    // Ferme les menus à chaque changement de page
    useEffect(() => {
        dispatch(openLangSelector(false));
        dispatch(openMenuMobile(false));
    }, [location.pathname, dispatch]);

    // Calcul des dimension du header
    useEffect(() => {
        if (!headerRef.current) return;

        const updateHeaderDimension = () => {
            const height = headerRef.current.offsetHeight;
            dispatch(setHeaderHeight(height));

            const width = headerRef.current.offsetWidth;
            dispatch(setHeaderWidth(width));
        };

        updateHeaderDimension();
        window.addEventListener('resize', updateHeaderDimension);

        const resizeObserver = new ResizeObserver(updateHeaderDimension);
        resizeObserver.observe(headerRef.current);

        return () => {
            window.removeEventListener('resize', updateHeaderDimension);
            resizeObserver.disconnect();
        };
    }, [dispatch]);

    // Gestion du scroll
    const handleScroll = useCallback(() => {
        const currentPosition = window.scrollY;

        // Si on scroll vers le haut
        if (currentPosition < scrollPosition) {
            setIsVisible(true);
            setScrollReference(currentPosition); // Réinitialise la référence
        }
        // Si on scroll vers le bas
        else if (currentPosition > scrollPosition) {
            // Calculer la distance totale scrollée depuis la référence
            const totalScrolledDown = currentPosition - scrollReference;

            // Si on a scrollé vers le bas d'au moins la hauteur du header
            if (totalScrolledDown >= headerHeight) {
                setIsVisible(false);
            }
        }

        setScrollPosition(currentPosition);
    }, [scrollPosition, headerHeight, scrollReference]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    // Calcul de la position du header
    const headerTranslateY = isVisible ? 0 : -headerHeight;

    return (
        <header
            ref={headerRef}
            style={{
                transform: `translateY(${headerTranslateY}px)`,
                transition: "transform 0.3s ease",
            }}
        >
            <div className="title">
                <button onClick={() => goPage('')}>
                    <h1><span className="red">V</span>anRa<span className="red">h</span></h1>
                    <span className="bar">-</span>
                    <p>Original Manga <span className="red">A</span>rtist</p>
                </button>
            </div>

            <nav className={`nav_mobile ${isOpen ? 'nav_open' : ''}`}>
                <button
                    className="btn_open"
                    onClick={() => dispatch(openMenuMobile(!isOpen))}
                >menu</button>

                <div className="menu">
                    <i className="star_bar_top"></i>
                    <i className="logo_left"></i>
                    <ul>
                        <li>
                            <i className="star"></i>
                            <button onClick={() => goPage('')}>VanRah</button>
                            <i className="star"></i>
                        </li>
                        <li>
                            <i className="star"></i>
                            <button onClick={() => goPage('illustrations')}>Illustrations</button>
                            <i className="star"></i>
                        </li>
                        <li>
                            <i className="star"></i>
                            <button onClick={() => goPage('mangas')}>Mangas</button>
                            <i className="star"></i>
                        </li>
                        <li>
                            <i className="star"></i>
                            <button onClick={() => goPage('works')}>Other Works</button>
                            <i className="star"></i>
                        </li>
                        <li>
                            <i className="star"></i>
                            <button onClick={() => goPage('planning')}>Planning</button>
                            <i className="star"></i>
                        </li>
                        <li>
                            <i className="star"></i>
                            <button onClick={() => goPage('contact')}>Contact</button>
                            <i className="star"></i>
                        </li>
                        <li>
                            <i className="star"></i>
                            <button onClick={() => goPage('shop')}>Shop</button>
                            <i className="star"></i>
                        </li>
                    </ul>

                    <i className="logo_right"></i>
                    <i className="star_bar_bottom"></i>
                </div>
            </nav>

            <nav className="nav_desktop">
                <ul>
                    <li><button onClick={() => goPage('')}>VanRah</button></li>
                    <li><button onClick={() => goPage('illustrations')}>Illustrations</button></li>
                    <li><button onClick={() => goPage('mangas')}>Mangas</button></li>
                    <li><button onClick={() => goPage('works')}>Other Works</button></li>
                    <li><button onClick={() => goPage('planning')}>Planning</button></li>
                    <li><button onClick={() => goPage('contact')}>Contact</button></li>
                    <li><button onClick={() => goPage('shop')}>Shop</button></li>
                </ul>
            </nav>
        </header>
    );
}

export default Header;